import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";
import PageLoader from "../common/ui/PageLoader";
import { rememberRedirectUrl } from "../common/utils/redirectUrl";

type PrivateRouteProps = {
  children?: React.ReactNode; // Optional children prop
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { AuthUser, AuthIsLoading, AuthLogout } = useAuth();
  const location = useLocation();

  if (AuthIsLoading) return <PageLoader />;

  if (AuthUser === null) {
    // Pass the route explicitly: the browser is still on it, but this render is
    // what refuses it, so window.location is not a reliable source here.
    rememberRedirectUrl(`${location.pathname}${location.search}`);
    return <Navigate to="/auth" />;
  }

  if (
    (AuthUser.role === 2 && location.pathname.includes("platform")) ||
    (AuthUser.role === 1 && location.pathname.includes("client"))
  ) {
    AuthLogout({ redirect: false });
    return <Navigate to="/auth" />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default PrivateRoute;
